import React, { useEffect, useState } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../general/general-component/abstruct-component/AbstructLang';
import { loadProjectTypes } from '../../store/Actions/ActionProjectType';
import { Form } from '../general/general-component/abstruct-component/AbstructForm';
import { VariableEvaluation } from './VariableEvaluation';
import { putEvaluationType } from '../../store/Actions/ActionEvaluationType';
import { useSelectorCustom } from '../general/general-component/abstruct-component/useSelectorCustom';
import '../../assets/styles/StylePopup.css'

function EditEvaluationType({ arr, open, setOpen }) {
    const { mode, dispatch, navigate, langLocal } = AbstructVar();
    const { translate } = AbstructLang();
    const { state, setStateCustom, setLoad, setState } = VariableEvaluation();
    const { projectTypes } = useSelectorCustom()
    const [customprojectTypes, setcustomprojectTypes] = useState([])
    useEffect(() => {
        dispatch(loadProjectTypes())
    }, []);
    useEffect(() => {
        console.log(projectTypes)
        if (projectTypes?.length > 0) {
            const temp = projectTypes?.map((item) => ({
                value: item?.id,
                label: item?.name
            }))
            setcustomprojectTypes(temp)
        }
    }, [projectTypes]);

    useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            name: arr.name,
            constraint: arr.constraint,
            evaluation_type: arr.evaluation_type,
            creative_work_type_id: arr.creative_work_type.id
        }));
    }, [arr]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(putEvaluationType(arr.id, state.name, state.constraint, state.evaluation_type, state.creative_work_type_id, setLoad));
    };
    const formFields = [
        { name: 'name', label: 'name', type: 'text', inputType: 'text', iconType: "pencil" },
        {
            name: "constraint", label: "Constraint", type: "text", inputType: 'one_select', iconType: "pencil",
            options: [{ value: 'optional', label: 'Optional' }, { value: 'required', label: 'Required' }],
            defaultvaluee: { value: state.constraint, label: state.constraint }
        },
        {
            name: "evaluation_type", label: "Evaluation Type", type: "text", inputType: 'one_select', iconType: "pencil",
            options: [{ value: 'question', label: 'Question' }, { value: 'normal', label: 'Normal' }],
            defaultvaluee: { value: state.evaluation_type, label: state.evaluation_type }
        },
        {
            name: "creative_work_type_id", label: "Project Type", type: "text", inputType: 'one_select', iconType: "pencil",
            options: customprojectTypes,
            defaultvaluee: { value: state.creative_work_type_id }
        },
    ];

    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: 'popupR',
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? 'darkPopUp' : 'lightPopUp'}`}>
                <div className={`div_title_popup ${mode === 'dark' ? 'darktoppopup' : 'lighttoppopup'}`}>
                    <p className={`title_popup ${mode === 'dark' ? 'darktext' : 'lighttext'}`}>{translate('edit_project_type')}</p>
                </div>
                <Form langLocal={langLocal} fields={formFields} handleSubmit={handleSubmit} state={state} setStateCustom={setStateCustom} translate={translate} buttonLabel="edit" />
            </div>
        </RModal>
    );
}

export default EditEvaluationType;

